import * as React from 'react';
import type { SVGProps } from 'react';
const List = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M228 128C228 131.183 226.736 134.235 224.485 136.485C222.235 138.736 219.183 140 216 140H40C36.8174 140 33.7652 138.736 31.5147 136.485C29.2643 134.235 28 131.183 28 128C28 124.817 29.2643 121.765 31.5147 119.515C33.7652 117.264 36.8174 116 40 116H216C219.183 116 222.235 117.264 224.485 119.515C226.736 121.765 228 124.817 228 128ZM40 76H216C219.183 76 222.235 74.7357 224.485 72.4853C226.736 70.2348 228 67.1826 228 64C228 60.8174 226.736 57.7652 224.485 55.5147C222.235 53.2643 219.183 52 216 52H40C36.8174 52 33.7652 53.2643 31.5147 55.5147C29.2643 57.7652 28 60.8174 28 64C28 67.1826 29.2643 70.2348 31.5147 72.4853C33.7652 74.7357 36.8174 76 40 76ZM216 180H40C36.8174 180 33.7652 181.264 31.5147 183.515C29.2643 185.765 28 188.817 28 192C28 195.183 29.2643 198.235 31.5147 200.485C33.7652 202.736 36.8174 204 40 204H216C219.183 204 222.235 202.736 224.485 200.485C226.736 198.235 228 195.183 228 192C228 188.817 226.736 185.765 224.485 183.515C222.235 181.264 219.183 180 216 180Z"
      fill="currentColor"
    />
  </svg>
);
export default List;
